export default __webpack_public_path__ + "static/media/(19).cdba8b09.jpeg";